module.exports = __webpack_public_path__ + "img/sword-water-04.e6680dda.png";